import {Box, Modal, Paper} from "@material-ui/core"
import React from "react"
import {styled} from "@mui/material/styles"

import {OfferModalForm} from "./OfferModalForm"
import {OfferModalReview} from "./OfferModalReview"

import {api, type SettlementOfferResponse} from "@indebted/api"
import {useNotification} from "@indebted/components/Notification"

type OfferData = SettlementOfferResponse

function OfferModal({offerData, customerID, onClose}: {offerData: OfferData; customerID: string; onClose: () => void}) {
	const [Component, setComponent] = React.useState<React.ReactNode>(<></>)
	const {notification} = useNotification()

	React.useEffect(() => {
		function createDiscountOffer(date: string, percentage: string | undefined) {
			api.customer
				.settlementOfferCreate(customerID, {
					CampaignEndDate: date,
					Discount: percentage,
					AccountIDs: offerData.Accounts,
				})
				.then(() => {
					onClose()
					notification.success(`Offer created successfully.`)
				})
				.catch((error) => {
					notification.error(error.Message)
					onClose()
				})
		}
		function calculateDiscountedAmount(date: string, percentage: string | undefined) {
			api.customer
				.settlementOfferCalculate(customerID, {
					CampaignEndDate: date,
					Discount: percentage,
					AccountIDs: offerData.Accounts,
				})
				.then((response) => {
					setComponent(
						<OfferModalReview
							offerData={response}
							onCancel={onClose}
							onSubmit={() => createDiscountOffer(date, percentage)}
							onBack={() =>
								setComponent(
									<OfferModalForm
										onCancel={onClose}
										onCalculate={calculateDiscountedAmount}
										offerData={offerData}
										storedData={{date}}
									/>,
								)
							}
						/>,
					)
				})
				.catch((error) => {
					setComponent(
						<OfferModalForm
							offerData={offerData}
							onCalculate={calculateDiscountedAmount}
							onCancel={onClose}
							error={error.Message}
						/>,
					)
				})
		}
		setComponent(
			<OfferModalForm onCancel={onClose} onCalculate={calculateDiscountedAmount} offerData={offerData} />,
		)
	}, [offerData, customerID, notification, onClose])

	return (
		<Modal open={true} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
			<StyledPaper>
				<Box style={{width: "100%"}}>{Component}</Box>
			</StyledPaper>
		</Modal>
	)
}

const StyledPaper = styled(Paper)`
	padding: 10px 20px 30px 20px;
	position: relative;
	width: 450px;
	max-height: 95%;
	outline: none;
	overflow: auto;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	@media screen and (max-width: 599px) {
		width: 90%;
	}
`

export {OfferModal}
